module.exports = __webpack_public_path__ + "static/media/instagram.28662376.png";